module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-how-it-works"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-content-inner"
  }, [_vm._m(1), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-area"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "443",
      "height": "362",
      "src": "images/How-It-Works/howitworks01.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "learn-more-button",
    attrs: {
      "to": "/open-info-request-website",
      "tag": "button"
    }
  }, [_c('span', [_vm._v("CLICK HERE TO REQUEST MORE INFORMATION")])])], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('hr', {
    staticClass: "frl-hr"
  }), _vm._v(" "), _vm._m(5)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbo-wrapper how-it-works"
  }, [_c('div', {
    staticClass: "jumbo-main"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('p', {
    staticClass: "t15"
  }, [_vm._v("HOW IT WORKS")]), _vm._v(" "), _c('h2', {
    staticClass: "t42"
  }, [_vm._v("\n                    ALWAYS KNOW WHAT\n                    "), _c('br'), _vm._v("\n                    YOU NEED, AND WHEN\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "t20"
  }, [_vm._v("A streamlined process created with you in mind.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "howitworks-howto"
  }, [_c('div', {
    staticClass: "howto-content"
  }, [_c('div', {
    staticClass: "howto-step"
  }, [_c('div', {
    staticClass: "step-content one"
  }, [_c('p', [_vm._v("\n                                REQUEST OUR"), _c('br'), _vm._v("\n                                FUNDRAISING TOOLKIT\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "step-number"
  }, [_c('div', {
    staticClass: "number-circle one"
  }, [_c('span', [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "howto-divider left"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-divider bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-step"
  }, [_c('div', {
    staticClass: "step-content two"
  }, [_c('p', [_vm._v("\n                                SUBMIT YOUR"), _c('br'), _vm._v("\n                                BRICK FUNDRAISER"), _c('br'), _vm._v("\n                                REGISTRATION\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "step-number"
  }, [_c('div', {
    staticClass: "number-circle two"
  }, [_c('span', [_vm._v("2")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "howto-divider left"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-divider bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-step"
  }, [_c('div', {
    staticClass: "step-content three"
  }, [_c('p', [_vm._v("\n                                LAUNCH YOUR"), _c('br'), _vm._v("\n                                FUNDRAISER\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "step-number"
  }, [_c('div', {
    staticClass: "number-circle three"
  }, [_c('span', [_vm._v("3")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "howto-divider leftmost"
  }), _vm._v(" "), _c('div', {
    staticClass: "howto-divider bottommost"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        WHEREVER YOUR STARTING POINT,\n                        OUR ROADMAP TO SUCCESS\n                        PROVIDES EVERYTHING YOU NEED!\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Whether you would like to know more or you are ready to start, our Roadmap to Success will take you where you need to go. Look for our marked required sections with links and checklists, as well as additional information, tips, and templates to take your fundraiser to the next level.\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "443",
      "height": "362",
      "src": "images/How-It-Works/howitworks02.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        MAKE IT OFFICIAL BY SELECTING\n                        YOUR PRODUCTS & PROGRAM\n                        INFORMATION.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Select your product details and initiate your Brick Fundraiser Website by filling out our Brick Fundraiser Registration Form. Find the link to the form in our Roadmap to Success, as well as a checklist to ensure no detail has been missed.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        ONCE SALES HAVE ENDED,\n                        PLACE YOUR ORDER\n                        THROUGH OUR ORDER\n                        SUBMISSION FORM.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        All orders are collected through our free website and integrated into a Google Sheet for easy management. This Google Sheet is also what is submitted to Fund Raisers, Ltd. to initiate production. Find the submission link in our Roadmap to Success, along with a checklist to ensure no detail has been missed.\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "443",
      "height": "362",
      "src": "images/How-It-Works/howitworks03.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-area"
  }, [_c('div', {
    staticClass: "body-area-left"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "443",
      "height": "362",
      "src": "images/How-It-Works/howitworks04.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "body-area-right"
  }, [_c('h6', {
    staticClass: "body-area-headline"
  }, [_vm._v("\n                        ORDER DELIVERY IN AS"), _c('br'), _vm._v("\n                        LITTLE AS 7 WEEKS.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Tracking information will be emailed once your order has been shipped. Your order will be shipped early if it is done early.\n                    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26be064b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/HowItWorks.vue
// module id = UnG1
// module chunks = 1